export default __webpack_public_path__ + "static/media/chrome.d46792dc.svg";